module.exports = {"510311100":"沿滩镇","510311101":"卫坪镇","510311102":"兴隆镇","510311105":"富全镇","510311106":"永安镇","510311107":"联络镇","510311108":"邓关镇","510311109":"王井镇","510311110":"黄市镇","510311111":"瓦市镇","510311112":"仙市镇","510311203":"刘山乡","510311204":"九洪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510311.json
// module id = 2278
// module chunks = 0